import { render, staticRenderFns } from "./regions-data.vue?vue&type=template&id=2f2dff1c"
import script from "./regions-data.vue?vue&type=script&lang=js"
export * from "./regions-data.vue?vue&type=script&lang=js"
import style0 from "./regions-data.vue?vue&type=style&index=0&id=2f2dff1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports